export const appRoutesNames = {
    LOGIN: 'login',
    RESET_PASSWORD: 'reset-password',
    CHANGE_PASSWORD: 'change-password',
    NEW_PASSWORD: 'new-password',
    NEWSLETTER_OPT_IN_OUT: 'newsletter-opt-in-out',
    VERSION: 'version',
    ERROR: 'error'
};
